import * as React from "react"
import MastheadProvider from 'providers/MastheadProvider';
import Navigation from "components/Navigation";

/**
 * The masthead will be loaded from a provider, but the back end still needs to be created for that.
 * 
*/
const Header = (props) => {
	const { pageContext } = props;
	return (
		<header>
			{ pageContext?.includeNavigation !== false && <Navigation {...{pageContext}} /> }
			{ pageContext?.includeMasthead !== false && <MastheadProvider /> }
		</header>
	)
}

export default React.memo(Header);